export const ROUTE_ROOT = '/';

export const ROUTE_FONT_PAGE = '/font';
export const ROUTE_FONT_CARD_PAGE = '/font-card';
